export class NotesEnvironment {
  public static getName = () => 'benzinga-notes';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://accounts.benzinga.com/'),
  });
}
